import { useMutation } from '@tanstack/react-query'
import { triageService } from '@/api/services/triageService'
import type {
  DispatchTriageRequest,
  DispatchTriageResponse,
} from '@/types/api/triage'
import { MUTATION_KEYS } from '@/config/api'

export const useDispatchTriage = () => {
  return useMutation<DispatchTriageResponse, Error, DispatchTriageRequest>({
    mutationKey: [MUTATION_KEYS.DISPATCH_TRIAGE],
    mutationFn: (payload: DispatchTriageRequest) =>
      triageService.dispatchTriage(payload),
  })
}

export default useDispatchTriage
